module.exports = __webpack_public_path__ + "img/744.194d03bf.jpg";